export default __webpack_public_path__ + "static/3-0_HSR_Icon-d6bc82c511fdc2f40ba8e28cadeb4928.png";